import LanguageSwitcherDesktop from "./LanguageSwitcherDesktop";

export default LanguageSwitcherDesktop;
